<template lang="pug">
#login.h-screen.w-screen.flex.items-center.justify-center.p-2.background
  form.w-full.max-w-md.p-4.relative.shadow(@submit.prevent="submit")
    .absolute.w-full.h-full.top-0.left-0.bg-gray-100.opacity-75.rounded
    .relative
      img.w-24.mx-auto.mb-4(src="/images/logo.png" alt="Grownce")

      .text-red-500.mb-4.text-sm(v-if="error") {{ error }}

      .bg-white.rounded.shadow.overflow-hidden.mb-4
        .h-12.border-b.border-gray-300.relative
          input.h-12.pl-12.pr-4.bg-transparent.absolute.top-0.left-0.w-full(type="text" name="username" placeholder="Username" class="focus:bg-gray-200" v-model.trim="username")
          .flex.items-center.justify-center.w-12.h-12.text-gray-700.absolute.top-0.left-0
            i.fa.fa-user
        .h-12.border-b.border-gray-300.relative
          input.h-12.pl-12.pr-4.bg-transparent.absolute.top-0.left-0.w-full(type="password" name="password" placeholder="Password" class="focus:bg-gray-200" v-model.trim="password")
          .flex.items-center.justify-center.w-12.h-12.text-gray-700.absolute.top-0.left-0
            i.fa.fa-key

      button.w-full.h-12.bg-teal-500.rounded.shadow.text-white(class="hover:bg-teal-600" :disabled="isSubmitting")
        i.fa.fa-sign-in-alt.mr-2
        span Login
</template>

<script>
import axios from 'axios'
import { createComponent, ref } from '@vue/composition-api'

export default createComponent({
  setup (props, context) {
    const username = ref('')
    const password = ref('')
    const isSubmitting = ref(false)
    const error = ref('')

    async function submit () {
      if (!username.value || !password.value) {
        return
      }

      if (isSubmitting.value) {
        return
      }

      error.value = ''

      isSubmitting.value = true

      window.$LOADER.show('Logging in...')

      try {
        await axios.post('/api/admin/login', {
          username: username.value,
          password: password.value
        })

        isSubmitting.value = false

        context.root.$router.push('/dashboard/users')

        window.$LOADER.hide()
      } catch (err) {
        isSubmitting.value = false

        error.value = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Invalid credentials.'

        window.$LOADER.hide()
      }
    }

    return {
      username,
      password,
      error,
      submit,
      isSubmitting
    }
  }
})
</script>
